// Native
import { useState } from "react"
import { useNavigate } from "react-router"
import { Button, DialogBody, HStack, Separator, Stack, Text } from "@chakra-ui/react"
import { useQueryClient } from "@tanstack/react-query"

// Custom
import { Form, UI } from "components"
import { API, Mask, toaster } from "config"
import useUser from "hooks/useUser"

export default function Address(props){

    const navigate = useNavigate()
    const queryClient = useQueryClient()
    const user = useUser()
    const address = user.data?.address ?? {}
    const [ form, setForm ] = useState(address)
    const [ errors, setErrors ] = useState()
    const [ loading, setLoading ] = useState(false)

    const handleChange = ({ target }) => {
        const { name, value } = target
        switch(name){
            default: setForm({...form, [name]: value}); break;
            case 'zip': setForm({...form, [name]: Mask.zip(value)}); break;
        }
    }

    const handleSubmit = async () => {
        setLoading(true)

        try{
            await API.put('/me/address', form)
            toaster.create({ title: 'Endereço atualizado!', type: 'success' })
            queryClient.invalidateQueries('user')
        }catch(err){
            setErrors(err?.response?.data?.errors)
            toaster.create({ title: 'Não foi possível atualizar o endereço. Tente novamente', description: err?.response?.data?.message, type: 'warning' })
        }

        setLoading(false)
    }

    return(
    <UI.Dialog title="Finalize seu cadastro" loading {...props}>
        <DialogBody>
            <Stack gap={4}>

                <Text>Para continuar com o seu processo de adesão, precisamos que você atualize o seu endereço.</Text>

                <Separator />

                <Form.Container onSubmit={handleSubmit}>

                    <Form.Location required defaultCity={user.data?.address?.city} disabled={loading} onChange={value => handleChange({ target: { name: 'city_id', value } })} />

                    <UI.Show visible={!!form?.city_id}>
                        <Separator />

                        <Stack gap={1}>
                            <Form.Text
                                required
                                label="Endereço (Linha 1):"
                                name="line_1"
                                value={form?.line_1}
                                defaultValue={address.line_1}
                                error={errors?.line_1}
                                onChange={handleChange}
                                placeholder="Ex.: Av. Brasil Sul"
                                disabled={loading}
                                size="sm"
                            />

                            <Form.Text
                                placeholder="Endereço (Linha 2):"
                                name="line_2"
                                value={form?.line_2}
                                defaultValue={address.line_2}
                                error={errors?.line_2}
                                onChange={handleChange}
                                disabled={loading}
                                size="sm"
                            />
                        </Stack>

                        <HStack alignItems="flex-start">
                            <Form.Text
                                required
                                label="CEP:"
                                name="zip"
                                value={form?.zip}
                                defaultValue={Mask.zip(address.zip)}
                                error={errors?.zip}
                                onChange={handleChange}
                                placeholder="Ex.: 74 023 010"
                                disabled={loading}
                                size="sm"
                                helper="O código postal do seu endereço."
                            />

                            <Form.Text
                                required
                                label="Bairro/Setor:"
                                name="neighborhood"
                                value={form?.neighborhood}
                                defaultValue={address.neighborhood}
                                error={errors?.neighborhood}
                                onChange={handleChange}
                                placeholder="Ex.: Setor Central"
                                disabled={loading}
                                size="sm"
                            />
                        </HStack>

                        <HStack>

                            <Form.Text
                                label="Número:"
                                name="number"
                                value={form?.number}
                                defaultValue={address.number}
                                error={errors?.number}
                                onChange={handleChange}
                                placeholder="Ex.: 860"
                                disabled={loading}
                                size="sm"
                            />

                            <Form.Text
                                label="Complemento:"
                                name="complement"
                                value={form?.complement}
                                defaultValue={address.complement}
                                error={errors?.complement}
                                onChange={handleChange}
                                placeholder="Ex.: 860"
                                disabled={loading}
                                size="sm"
                            />

                        </HStack>
                    </UI.Show>

                    <Button type="submit" size="lg" colorPalette="orange" loading={loading} loadingText="Aguarde...">Continuar <UI.Icon name="next" /></Button>
                    <Button onClick={() => navigate('/logout')} variant="ghost" colorPalette="red" disabled={loading}><UI.Icon name="logout" /> Sair da minha conta</Button>
                </Form.Container>

            </Stack>
        </DialogBody>   
    </UI.Dialog>
    )
}